module.exports = __webpack_public_path__ + "static/media/FRAGMENTACION.0e47fd8b.png";